"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Carousel.css");

var _react = _interopRequireDefault(require("react"));

var _map = _interopRequireDefault(require("lodash/map"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _classnames = _interopRequireDefault(require("classnames"));

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var Carousel = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(Carousel, _React$Component);

  var _super = _createSuper(Carousel);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "prevValue", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "nextValue", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "currentValue", _descriptor3, _assertThisInitialized(_this));

    _this.currentValue = _this.props.default;
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.timeInterval) {
        this.startTimer();
      }
    }
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;

      this.timer = setInterval(function () {
        _this2.nextSlide();
      }, this.props.timeInterval);
    }
  }, {
    key: "resetTimer",
    value: function resetTimer() {
      if (this.props.timeInterval) {
        clearInterval(this.timer);
        this.startTimer();
      }
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      this.updateChild((this.currentValue + 1) % this.props.children.length);
    }
  }, {
    key: "prevSlide",
    value: function prevSlide() {
      this.updateChild(this.currentValue - 1 < 0 ? this.props.children.length - 1 : this.currentValue - 1);
    }
  }, {
    key: "updateChild",
    value: function updateChild(child) {
      this.prevValue = this.currentValue;
      this.nextValue = child;
      this.resetTimer(); // Resetting the timer to avoid wonky double slide updates
    }
  }, {
    key: "updateNext",
    value: function updateNext() {
      this.currentValue = this.nextValue;
      this.prevValue = -1;
      this.nextValue = -1;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-children"
      }, (0, _map.default)(children, function (child, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: i,
          className: (0, _classnames.default)("carousel-child", {
            selected: _this3.currentValue === i,
            previous: _this3.prevValue === i
          }),
          onAnimationEnd: _this3.prevValue === i ? _this3.updateNext : _noop.default,
          tabIndex: _this3.currentValue === i ? 0 : -1
        }, child);
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-indicator-arrows"
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: "prev-child",
        "aria-label": "Prev Slide",
        onClick: this.prevSlide
      }, "\u2039"), /*#__PURE__*/_react.default.createElement("button", {
        className: "next-child",
        "aria-label": "Next Slide",
        onClick: this.nextSlide
      }, "\u203A")), /*#__PURE__*/_react.default.createElement("div", {
        className: "carousel-indicator-section"
      }, (0, _map.default)(children, function (child, i) {
        return /*#__PURE__*/_react.default.createElement("button", {
          key: i,
          className: (0, _classnames.default)("carousel-indicators", {
            selected: _this3.currentValue === i
          }),
          onClick: function onClick() {
            return _this3.updateChild(i);
          },
          name: i,
          disabled: _this3.currentValue === i
        });
      })));
    }
  }]);

  return Carousel;
}(_react.default.Component), _defineProperty(_class3, "defaultProps", {
  timeInterval: false // Default: timer is off

}), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "prevValue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "nextValue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "currentValue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "startTimer", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "startTimer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "resetTimer", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "resetTimer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nextSlide", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "nextSlide"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "prevSlide", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "prevSlide"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateChild", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "updateChild"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateNext", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "updateNext"), _class2.prototype)), _class2)) || _class;

var _default = Carousel;
exports.default = _default;